export const TEST_ACTION_INCREMENT = "TEST_COUNT_INCREMENT";
export const TEST_ACTION_DECREMENT = "TEST_COUNT_DECREMENT";
export const TEST_ACTION_MANUEL = "TEST_COUNT_MANUEL";
export const TEST_ACTION_RESET = "TEST_ACTION_RESET";
export const PBH_REQUEST_UPDATE_OPEN = "PBH_REQUEST_UPDATE_OPEN";
export const PBH_REQUEST_UPDATE_CLOSE = "PBH_REQUEST_UPDATE_CLOSE";
export const PBH_REQUEST_SET_FILES = "PBH_REQUEST_SET_FILES";
export const PBH_REQUEST_SET_FILES_LOADING = "PBH_REQUEST_SET_FILES_LOADING";
export const PBH_DASHBOARD_MODEL_CHANGED = "PBH_DASHBOARD_MODEL_CHANGED";
export const PBH_REQUEST_MODEL_CLEAR = "PBH_REQUEST_MODEL_CLEAR";
